var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getInitials } from "../utils/userUtils";
import { getActiveMembership, parseIdToken, checkIfEmployee, getAppMetadataFromPayload, getLogoutRedirectUrl, } from "./getUserHelpers";
export function getApUserFromIdToken(rawIdToken) {
    var decodedIdTokenPayload = parseIdToken(rawIdToken);
    var userAppMetadata = getAppMetadataFromPayload(decodedIdTokenPayload);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var authalId = userAppMetadata.authalId, _memberships = userAppMetadata.memberships, _profile = userAppMetadata.profile, rest = __rest(userAppMetadata, ["authalId", "memberships", "profile"]);
    var activeMembership = getActiveMembership(userAppMetadata);
    var firstName = decodedIdTokenPayload.givenName;
    var lastName = decodedIdTokenPayload.familyName;
    var email = decodedIdTokenPayload.email;
    return __assign(__assign({}, rest), { firstName: firstName,
        lastName: lastName, fullName: ((firstName || "") + " " + (lastName || "")).trim(), id: authalId, email: email, userInitial: getInitials({ firstName: firstName, lastName: lastName, email: email }), activeMembership: activeMembership, isEmployee: checkIfEmployee(decodedIdTokenPayload), logoutRedirectUrl: getLogoutRedirectUrl(decodedIdTokenPayload) });
}
